import axios from 'axios';
import API_BASE_URL from './api';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// อ่าน token จาก localStorage ทุกครั้งที่เรียก (กัน token เก่าหรือเพิ่ง login)
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default axiosInstance;


// การนำไปใช้งานใช้แบบนี้
// ทำการ import จาก ไฟล์ axiosInstance แทนการ import จาก axios
// import axios from '../config/axiosInstance';

// export const getUsers = () => axios.get('/users');
